var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.960693H513V342.927H0V0.960693Z",
    fill: "#C60A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171.994L44.5869 298.34V45.5476L256.5 171.994Z",
    fill: "#3E8446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171.994L468.413 298.34H44.5869L256.5 171.994ZM468.413 45.5476L256.5 171.994L44.5869 45.5476H468.413Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.413 45.5476V298.34L256.5 171.994L468.413 45.5476Z",
    fill: "#3E8446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 11.381L259.806 21.6009H270.527L261.91 27.9132L265.217 38.1331L256.5 31.8208L247.783 38.1331L251.089 27.9132L242.473 21.6009H253.193L256.5 11.381ZM170.432 11.381L173.739 21.6009H184.459L175.843 27.9132L179.149 38.1331L170.432 31.8208L161.715 38.1331L165.022 27.9132L156.405 21.6009H167.126L170.432 11.381ZM342.568 11.381L345.874 21.6009H356.695L347.978 27.9132L351.285 38.1331L342.568 31.8208L333.851 38.1331L337.157 27.9132L328.54 21.6009H339.261L342.568 11.381ZM256.5 305.755L259.806 315.975H270.527L261.91 322.287L265.217 332.507L256.5 326.195L247.783 332.507L251.089 322.287L242.473 315.975H253.193L256.5 305.755ZM170.432 305.755L173.739 315.975H184.459L175.843 322.287L179.149 332.507L170.432 326.195L161.715 332.507L165.022 322.287L156.405 315.975H167.126L170.432 305.755ZM342.568 305.755L345.874 315.975H356.695L347.978 322.287L351.285 332.507L342.568 326.195L333.851 332.507L337.157 322.287L328.54 315.975H339.261L342.568 305.755Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.977 248.343C287.144 248.343 321.326 214.16 321.326 171.994C321.326 129.828 287.144 95.6453 244.977 95.6453C202.811 95.6453 168.629 129.828 168.629 171.994C168.629 214.16 202.811 248.343 244.977 248.343Z",
    fill: "#C60A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.978 111.276L258.604 153.157H302.69L267.021 179.008L280.647 220.889L244.978 195.039L209.408 220.889L223.035 179.008L187.365 153.157H231.451L244.978 111.276ZM107.91 169.088C112.319 176.002 110.215 185.22 103.301 189.628C96.388 194.037 87.17 191.933 82.7614 185.02C74.846 172.495 79.455 151.955 79.455 151.955C79.455 151.955 99.8948 156.564 107.91 169.088Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2936 190.831C103.388 190.831 106.708 187.511 106.708 183.416C106.708 179.322 103.388 176.002 99.2936 176.002C95.1987 176.002 91.8792 179.322 91.8792 183.416C91.8792 187.511 95.1987 190.831 99.2936 190.831Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.960693)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/GD.b1fcd76246880ed4a9f9419443f942bb.svg";
export { ForwardRef as ReactComponent };